export default {
  required: 'required',
  max_length: 'max_length',
  min_length: 'min_length',
  is_url: 'is_url',
  is_email: 'is_email',
  password: 'password',
  one_comma: 'one_comma',
};
